import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import illustrationLeftImg from './img/illustration-left.png'
import illustrationRightImg from './img/illustration-right.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM'
      : 'VÃO SE CASAR'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro314">
      <div className="intro314mobile screen">
        <div className="main-background-L3YYKd">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="background-image" />
          )}
        </div>
        <div className="container-center-horizontal">
          <div className="button-L3YYKd">
            <div
              className="site-de-casamento-e-FYA6HG"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-FYA6HG" onClick={onSkipIntro}>
              <div className="button-OU3tFg"></div>
              <div className="pular-introduo-OU3tFg">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <img
          className="illustration-left-L3YYKd bp2-intro314-animate-enter"
          src={illustrationLeftImg}
        />
        <img
          className="illustration-right-L3YYKd bp2-intro314-animate-enter1"
          src={illustrationRightImg}
        />
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-L3YYKd">
            <div className="vo-se-casar-Ai7NMA bp2-intro314-animate-enter2">
              {text}
            </div>
            <div className="couple-single-namebr-Ai7NMA valign-text-middle bp2-intro314-animate-enter3 notranslate">
              <p>{coupleSingleName.bride}</p>
              {coupleSingleName.groom && <p>& {coupleSingleName.groom}</p>}
            </div>
          </div>
        </div>
      </div>
      <div className="intro314desktop screen">
        <div className="main-background-Kee1HM bp1-intro314-animate-enter">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="background-image" />
          )}
        </div>
        <img
          className="illustration-left-Kee1HM bp1-intro314-animate-enter1"
          src={illustrationLeftImg}
        />
        <img
          className="illustration-right-Kee1HM bp1-intro314-animate-enter2"
          src={illustrationRightImg}
        />
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-Kee1HM">
            <div className="vo-se-casar-oxmwB5 bp1-intro314-animate-enter3">
              {text}
            </div>
            <div className="couple-single-namebr-oxmwB5 valign-text-middle bp1-intro314-animate-enter4 notranslate">
              <p>{coupleSingleName.bride}</p>
              {coupleSingleName.groom && <p>& {coupleSingleName.groom}</p>}
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="button-Kee1HM">
            <div
              className="site-de-casamento-e-nynPJI"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-nynPJI" onClick={onSkipIntro}>
              <div className="button-zjFPh8"></div>
              <div className="pular-introduo-zjFPh8">{buttonMessage}</div>
            </button>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
